import { CalendarOff } from 'lucide-react';

const sessionLabel = (iso) => {
  if (!iso) return 'the last session';
  const d = new Date(`${iso}T12:00:00`);
  if (Number.isNaN(d.getTime())) return 'the last session';
  return `${d.toLocaleDateString('en-US', { weekday: 'long' })}'s`;
};

// "Market closed for Labor Day — showing Friday's movers" note shown on
// the Movers News strip + page whenever the exchanges are shut today.
export default function MarketClosedBanner({ note, compact = false, testId = 'market-closed-banner' }) {
  if (!note || !note.reason) return null;
  const when = sessionLabel(note.session_day);
  const dateStr = note.session_day
    ? new Date(`${note.session_day}T12:00:00`).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    : null;
  return (
    <div
      className={`flex items-center gap-2 rounded-md border border-amber-400/60 dark:border-amber-500/40 bg-amber-50/70 dark:bg-amber-950/30 text-amber-900 dark:text-amber-200 ${compact ? 'px-2.5 py-1 text-[11px]' : 'px-3 py-2 text-xs sm:text-sm'} font-semibold`}
      role="status"
      data-testid={testId}
    >
      <CalendarOff className={`${compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} shrink-0 text-amber-600 dark:text-amber-400`} />
      <span>
        Market closed for <span className="font-extrabold">{note.label}</span>
        {' — '}showing {when} movers{dateStr ? <span className="font-mono font-normal opacity-80"> ({dateStr})</span> : null}
        {compact ? null : '. News below is from the last trading session; fresh movers return when the market reopens.'}
      </span>
    </div>
  );
}
